/**
 * Type of attribute(s) or characteristic(s) associated with the transaction.
 * tag: 2872
 * @readonly
 * @enum {number} (int)
 */
export enum TransactionAttributeType {
  ExclusiveArrangement = 0,
  CollateralReuse = 1,
  CollateralArrangmentType = 2,
}
